import { createTheme } from '@mui/material/styles'
import {ThemeProvider } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useMemo, useState, createContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAccessToken } from './store/redusers/auth/selectors'
import { setThemeAction } from './store/redusers/user/actions'
import { selectUserTheme } from './store/redusers/user/selectors'
import { getDesignTokens } from './theme'

export const ColorModeContext = createContext({ toggleColorMode: () => {} })

function AppThemeProvider(props) {
	const dispatch = useDispatch()
	const userTheme = useSelector(selectUserTheme)
	const token = useSelector(selectAccessToken)
	localStorage.removeItem('trading-selected-asset')
	const [mode, setMode] = useState('light')
	const colorMode = useMemo(
		() => ({
			toggleColorMode: () => {
				setMode((prevMode) =>
					prevMode === 'light' ? 'dark' : 'light'
				)
			}
		}),
		[])
	useEffect(() => {
		if(JSON.parse(localStorage.getItem('trading-theme-dark'))) return setMode('dark')
		if(userTheme) {
			setMode(userTheme)
			localStorage.setItem('trading-theme-dark', JSON.stringify(userTheme === 'dark'))
		}
	}, [])
	useEffect(() => {
		if(userTheme) dispatch(setThemeAction(mode, token))
		localStorage.setItem('trading-theme-dark', JSON.stringify(mode === 'dark'))
	}, [mode])

	const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode])

	return (
		<ColorModeContext.Provider value={colorMode}>
			<ThemeProvider theme={theme}>
				{props.children}
			</ThemeProvider>
		</ColorModeContext.Provider>
	)
}

AppThemeProvider.propTypes = {
	children: PropTypes.node
}

export default AppThemeProvider




